export default {
  KLANT: "Klant",
  BANKZAKEN: "Bankzaken",
  POLISSEN: "Polissen",
  SCHADES: "Schades",
  HYPOTHEKEN: "Hypotheken",
  KREDIETEN: "Kredieten",
};
